import { type EntryIdInput, formatEntryId } from "./entryId";
import { createAction, type MutationAction } from "./mutationAction";
import { type ActionDeps, apiCall, refreshEntries } from "./types";

export function resolveFeedbackAction(
	entryId: EntryIdInput,
	deps: ActionDeps,
): MutationAction {
	const wireId = formatEntryId(entryId);
	return createAction({
		execute: () =>
			apiCall(deps, {
				endpoint: `/v2/entries/${wireId}/resolve-feedback`,
				method: "POST",
			}),
		rollback: null,
		toast: {
			loading: "Resolving feedback…",
			success: "Feedback resolved",
			error: "Failed to resolve feedback",
		},
		onSuccess: () => refreshEntries(deps),
		onError: () => refreshEntries(deps),
	});
}
